module.exports = __webpack_public_path__ + "img/execution_ipad.c343f9b0.gif";